module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/article-9-f8fc3bf742f05a788532c59c2cb8b407.jpg";